export default __webpack_public_path__ + "static/media/logo_transparent_bg.b3bf899e.png";